import { css } from 'linaria';

export const questionSectionTitle = css`
  margin-bottom: 24px;
`;

export const questionAccordion = css`
  && {
    @media (--only-largeDesktop) {
      width: 877px;
    }

    @media (--only-desktop) {
      width: 697px;
    }

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const questionDescriptionText = css`
  margin-bottom: 8px;
`;

export const questionDescriptionSubList = css`
  && {
    padding-left: 22px;
    margin-top: 8px;
    line-height: 20px;
    list-style-type: disc;

    li {
      padding-left: 0;
    }

    li::marker {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
